import * as React from 'react';
import PropTypes from 'prop-types';
import ol_Map from 'ol/Map';
import ol_View from 'ol/View';
import {defaults as ol_control_defaults} from 'ol/control';
import {defaults as ol_interaction_defaults} from 'ol/interaction';
import { Util } from './util';
import './ol.css';
import './map.css';
import { Controls } from "./controls";
import { Interactions } from "./interactions";
/**
 * Implementation of ol_map https://openlayers.org/en/latest/apidoc/ol_Map.html
 *
 * example:
 * <Map view={{center: [0, 0], zoom: 1}}>
 *   <layers>
 *     <layer.Tile source={new ol_source.OSM()} />
 *     <layer.Vector options={}/>
 *   </layers>
 *   <controls></controls>
 *   <interactions></interactions>
 *   <overlays></overlays>
 * </Map>
 */
class Map extends React.Component {
    /**
     * Component mounting LifeCycle; constructor, componentDidMount, and render
     * https://facebook.github.io/react/docs/react-component.html#mounting
     */
    constructor(props) {
        super(props);
        this.layers = [];
        this.interactions = [];
        this.controls = [];
        this.overlays = [];
        this.options = {
            pixelRation: undefined,
            keyboardEventTarget: undefined,
            loadTilesWhileAnimation: undefined,
            loadTilesWhileInteractiong: undefined,
            logo: undefined,
            renderer: undefined,
            //new options  for map component : setZoom, SetCenter, setResolution
            /* Added by : Harinder Randhawa */
            setCenter: undefined,
            setZoom: undefined,
            setResolution: undefined,
            view: new ol_View(props.view),
            controls: undefined,
            interactions: undefined,
            layers: undefined,
            overlays: undefined
        };
        this.events = {
            'change': undefined,
            'change:layerGroup': undefined,
            'change:size': undefined,
            'change:target': undefined,
            'change:view': undefined,
            'click': undefined,
            'dblclick': undefined,
            'moveend': undefined,
            'pointerdrag': undefined,
            'pointermove': undefined,
            'postcompose': undefined,
            'postrender': undefined,
            'precompose': undefined,
            'propertychange': undefined,
            'singleclick': undefined
        };
        this.map = undefined;
        console.log('Map constructor');
    }
    componentDidMount() {
        let options = Util.getOptions(Object.assign(this.options, this.props));
        !(options.view instanceof ol_View) && (options.view = new ol_View(options.view));
        let controlsCmp = Util.findChild(this.props.children, Controls) || {};
        let interactionsCmp = Util.findChild(this.props.children, Interactions) || {};
        options.controls = ol_control_defaults(controlsCmp.props).extend(this.controls);
        options.interactions = ol_interaction_defaults(interactionsCmp.props).extend(this.interactions);
        options.layers = this.layers;
        options.overlays = this.overlays;
        console.log('map options', options);
        this.map = new ol_Map(options);
        this.map.setTarget(options.target || this.mapDiv);
        //regitster events
        let olEvents = Util.getEvents(this.events, this.props);
        for (let eventName in olEvents) {
            console.log(eventName);
            this.map.on(eventName, olEvents[eventName]);
        }
    }
    // update the view with new props
    /* Modified by Harinder Randhawa */
    componentWillReceiveProps(nextProps) {
        if (this.props.view && nextProps.view.center !== this.props.view.center) {
            this.map.getView().setCenter(nextProps.view.center);
        }
        if (this.props.view && nextProps.view.zoom !== this.props.view.zoom) {
            this.map.getView().setZoom(nextProps.view.zoom);
        }
    }
    render() {
        return (React.createElement("div", { className: "openlayers-map1", style: this.props.style, ref: (el) => this.mapDiv = el }, this.props.children));
    }
    /**
     * Component Updating LifeCycle
     * https://facebook.github.io/react/docs/react-component.html#updating
     */
    //componentWillReceiveProps(nextProps)
    //shouldComponentUpdate(nextProps, nextState)
    //componentWillUpdate(nextProps, nextState)
    //componentDidUpdate(prevProps, prevState)
    /**
     * Component Unmounting LifeCycle
     * https://facebook.github.io/react/docs/react-component.html#unmounting
     */
    componentWillUnmount() {
        this.map.setTarget(undefined);
    }
    // Ref. https://facebook.github.io/react/docs/context.html#how-to-use-context
    getChildContext() {
        return {
            mapComp: this,
            map: this.map
        };
    }
}
// Ref. https://facebook.github.io/react/docs/context.html#how-to-use-context
Map.childContextTypes = {
    mapComp: PropTypes.instanceOf(Map),
    map: PropTypes.instanceOf(ol_Map)
};
export default Map;